import ConfirmModal from "../../../components/confirmModal/ConfirmModal";
import {HttpService} from "../../../services/http/Http.service";
import {message} from "antd";
import {HttpErrorService} from "../../../services/http/HttpError.service";
import {StatusCodeE} from "../../../model/models";
import {useTranslation} from "react-i18next";

interface PaymentConfirmedProps {
    onClose: () => void,
    simulatorId?: number | undefined,
    personId?: number | undefined,
    onStatusChange?: (() => void),
    fetchAuditTrail: () => Promise<void>
}

export default function PaymentConfirmedModal({
                                             onClose,
                                             simulatorId,
                                             personId,
                                             onStatusChange,
                                             fetchAuditTrail
                                         }: PaymentConfirmedProps) {

    const {t} = useTranslation();

    const confirmPayment = async () => {
        try {
            await HttpService.getInstanceAxios().post(`/file-ts/${simulatorId}/confirmPayment/${personId}`);

            message.success("Pratica riportata in stato Attesa Pagamento con successo");
            onClose();
            onStatusChange?.();
            await fetchAuditTrail()
        } catch (error) {
            HttpErrorService.handle("Errore durante il cambio stato della pratica", error, true);
        }
    };

    return (
        <>
            <ConfirmModal
                title={"Conferma pagamento"}
                visible={true}
                onConfirm={confirmPayment}
                onCancel={onClose}
                message={"Sei sicuro di voler confermare il pagamento e riportare la pratica in " + t(StatusCodeE.ATTESA_PAGAMENTO)}
            />
        </>
    )
}